import { useState, useMemo, useEffect } from 'react';

import CheckForm from './Check';
import Input from '../input';
import InputPhone from '@/components/InputPhone';
import Volanta from '../Volanta';
import BotonFormUnico from '../Botones/Formulario/Unico';
import cn from 'classnames';
import axios from 'axios';
import { isEmail, isPhone, isString } from '@/utils/common';
import { normalizeEmail } from '@/utils/normalizeEmail';
import RecaptchaLegend from '@/components/RecaptchaLegend';
import Link from 'next/link';
import { SelectBox, SelectBox2 } from '../SelectBox';
import SelectLocalidadProvincia from '@/components/SelectLocalidadProvincia';
import SelectDepartamentoProvinciaDistrito from '@/components/SelectDepartamentoProvinciaDistrito';

const DatosPersonales = ({
    form,
    onChange,
    check,
    setStep,
    country_short_name,
    id_type,
    localidades,
    distritos,
    provincias,
    departamentos,
    onChangeSelect,
}) => (
    <>
        <div className='mb-30'>
            <Volanta label='datos personales' />
        </div>
        <div className='personal-grid'>
            <div className='mb-24'>
                <Input
                    type='text'
                    name='doc_type'
                    id='doc_type'
                    placeholder='Tipo Doc'
                    value={id_type}
                    onChange={() => {}}
                    disabled={true}
                />
            </div>

            <div className='mb-24'>
                <Input
                    type='text'
                    name='doc'
                    id='doc'
                    placeholder='Nro de documento'
                    onChange={onChange}
                    value={form.doc}
                    hasError={check && !isString(form.doc)}
                />
            </div>

            <div className='mb-24'>
                <Input
                    type='text'
                    name='surnames'
                    id='surnames'
                    placeholder='Apellidos'
                    onChange={onChange}
                    value={form.surnames}
                    hasError={check && !isString(form.surnames, 2)}
                />
            </div>

            <div className='mb-24'>
                <Input
                    type='text'
                    name='names'
                    id='names'
                    placeholder='Nombres'
                    onChange={onChange}
                    value={form.names}
                    hasError={check && !isString(form.names, 2)}
                />
            </div>

            <div className='mb-24'>
                <Input
                    type='text'
                    name='address'
                    id='address'
                    placeholder='Direccion'
                    onChange={onChange}
                    value={form.address}
                    hasError={check && !isString(form.address, 2)}
                />
            </div>

            <div className='mb-24'>
                <Input
                    type='text'
                    name='email'
                    id='email'
                    placeholder='Correo electrónico'
                    onChange={onChange}
                    value={form.email}
                    hasError={check && !isEmail(form.email)}
                />
            </div>

            <div className='mb-24'>
                <label htmlFor='is_young' className='w-full'>
                    <span className='text-grey-dark'>¿Es mayor de edad?</span>
                    <SelectBox
                        name='is_young'
                        onChange={(x) =>
                            onChange({
                                target: { name: 'is_young', value: x.value },
                            })
                        }
                        value={form.is_young}
                        options={[
                            {
                                value: '1',
                                text: 'Si',
                            },
                            {
                                value: '0',
                                text: 'No',
                            },
                        ]}
                    />
                </label>
            </div>

            <div className='mb-24'>
                <Input
                    type='text'
                    name='phone'
                    id='phone'
                    placeholder='Teléfono / Celular'
                    onChange={onChange}
                    value={form.phone}
                    hasError={check && !isString(form.phone)}
                />
            </div>

            <div className='row-span-two'>
                {country_short_name === 'PE' ? (
                    <SelectDepartamentoProvinciaDistrito
                        departamentos={departamentos.departamentos || []}
                        provincias={provincias.provincias || []}
                        distritos={distritos.distritos || []}
                        check={check}
                        onChange={onChange}
                    />
                ) : (
                    <SelectLocalidadProvincia
                        localidades={localidades.localidades}
                        provincias={provincias.provincias}
                        check={check}
                        onChange={onChangeSelect}
                    />
                )}
            </div>
        </div>

        <div className='flex justify-center'>
            <div className='max-w-[21rem]'>
                <BotonFormUnico
                    onClick={() =>
                        isString(form.doc_type, 2) &&
                        isString(form.doc) &&
                        isString(form.surnames, 2) &&
                        isString(form.names, 2) &&
                        isEmail(form.email) &&
                        isString(form.is_young, 1) &&
                        isString(form.phone)
                            ? setStep(2)
                            : null
                    }
                    bgColor='button-gradient'
                    text='Siguiente'
                    disabled={
                        !(
                            isString(form.doc_type, 2) &&
                            isString(form.doc) &&
                            isString(form.surnames, 2) &&
                            isString(form.names, 2) &&
                            isEmail(form.email) &&
                            isString(form.is_young, 1) &&
                            isString(form.phone)
                        )
                    }
                />
            </div>
        </div>
    </>
);

const DatosReclamo = ({
    form,
    onChange,
    check,
    setStep,
    country_short_name,
}) => (
    <>
        <div className='mb-30'>
            <Volanta label='datos del reclamo' />
        </div>
        <div className='complain-grid'>
            <div className='mb-24'>
                <Input
                    type='date'
                    name='date'
                    id='date'
                    placeholder='Fecha'
                    onChange={onChange}
                    hasError={check && !isString(form.date)}
                />
            </div>
            <div className='mb-24'>
                <Input
                    type='text'
                    name='contact_subject'
                    id='contact_subject'
                    placeholder='Motivo de Contacto'
                    onChange={onChange}
                    hasError={check && !isString(form.contact_subject)}
                />
            </div>
            <div className='mb-24'>
                <Input
                    type='text'
                    name='complain_subject'
                    id='complain_subject'
                    placeholder='Motivo de Queja'
                    onChange={onChange}
                    hasError={check && !isString(form.complain_subject)}
                />
            </div>
            <div className='mb-24'>
                <Input
                    type='text'
                    name='tracking_nro'
                    id='tracking_nro'
                    placeholder='N° de envío'
                    onChange={onChange}
                    hasError={check && !isString(form.tracking_nro)}
                />
            </div>
            <div className='mb-24'>
                <Input
                    type='text'
                    name='point_info'
                    id='point_info'
                    placeholder='Información del Punto HOP'
                    onChange={onChange}
                    hasError={check && !isString(form.point_info)}
                />
            </div>
            <div className='mb-24'>
                <Input
                    type='text'
                    name='subject'
                    id='subject'
                    placeholder='Detalle'
                    onChange={onChange}
                    hasError={check && !isString(form.subject)}
                />
            </div>
            <div className='mb-24'>
                <Input
                    type='text'
                    name='expected_resolution'
                    id='expected_resolution'
                    placeholder='Resolución esperada'
                    onChange={onChange}
                    hasError={check && !isString(form.expected_resolution)}
                />
            </div>
        </div>
        <div className='flex justify-center'>
            <div className='max-w-[21rem]'>
                <BotonFormUnico
                    onClick={() => setStep(1)}
                    bgColor='button-gradient'
                    text='Atrás'
                />
            </div>
        </div>
    </>
);

const Form = ({
    finish,
    customer_services_complain,
    show_complains_tyc,
    country_short_name,
    form: form_name,
    id_type,
    localidades,
    distritos,
    provincias,
    departamentos,
}) => {
    const [form, setForm] = useState({
        doc_type: id_type,
        doc: '',
        surnames: '',
        address: '',
        names: '',
        email: '',
        is_young: '',
        phone: '',
        departamento: '',
        provincia: '',
        distrito: '',
        localidad: '',
        date: '',
        contact_subject: '',
        complain_subject: '',
        tracking_nro: '',
        point_info: '',
        subject: '',
        expected_resolution: '',
        country_code: country_short_name,
    });
    const [check, setCheck] = useState(false);
    const [loading, setLoading] = useState(false);
    const [step, setStep] = useState(1);
    const [errors, setErrors] = useState([]);

    useEffect(() => {
        setForm((prevForm) => ({
            ...prevForm,
            country_code: country_short_name,
            doc_type: id_type,
        }));
    }, [country_short_name, id_type]);

    const handlePhoneChange = (e) => {
        setForm((prevForm) => ({
            ...prevForm,
            phone: e.target.value,
            isValidPhone: e.target.isValid,
        }));
        setCheck(e.target.isValid);
    };

    useEffect(() => {
        console.log(Date.now(), form);
    }, [form]);

    const isFormComplete = useMemo(() => {
        setCheck(false);

        return (
            isString(form.doc_type, 2) &&
            isString(form.doc) &&
            isString(form.surnames, 2) &&
            isString(form.names, 2) &&
            isEmail(form.email) &&
            isString(form.is_young, 1) &&
            isString(form.phone) &&
            isString(form.provincia) &&
            isString(form.date) &&
            isString(form.contact_subject) &&
            isString(form.complain_subject) &&
            isString(form.tracking_nro) &&
            isString(form.point_info) &&
            isString(form.subject) &&
            isString(form.expected_resolution)
        );
    }, [form]);

    const onChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const onChangeCheckbox = (e) => {
        setForm({
            ...form,
            puntohop: false,
            ecommerce: false,
            comprador: false,
            [e.target.name]: !form[e.target.name],
        });
    };

    const submit = async (e) => {
        e.preventDefault();
        if (!isFormComplete) {
            setCheck(true);
            return;
        }
        setLoading(true);

        try {
            const { data } = await axios.post(
                location.origin + '/api/complain',
                { ...form, email: normalizeEmail(form.email) }
            );

            if (data.errors) {
                setErrors(data.errors);
                setLoading(false);
                return;
            }

            finish();
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    const onChangeSelect = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.text,
        });
    };

    return (
        <form onSubmit={submit}>
            {step === 1 ? (
                <DatosPersonales
                    onChangeSelect={onChangeSelect}
                    localidades={localidades}
                    distritos={distritos}
                    provincias={provincias}
                    departamentos={departamentos}
                    id_type={id_type}
                    country_short_name={country_short_name}
                    check={check}
                    form={form}
                    onChange={onChange}
                    setStep={setStep}
                />
            ) : (
                <DatosReclamo
                    country_short_name={country_short_name}
                    check={check}
                    form={form}
                    onChange={onChange}
                    setStep={setStep}
                />
            )}

            <div className='flex justify-center mt-20'>
                <div className='max-w-[21rem]'>
                    <BotonFormUnico
                        key={'submit-complain-form'}
                        bgColor='button-gradient'
                        type='submit'
                        text={loading ? 'Enviando...' : 'Enviar consulta'}
                        disabled={!isFormComplete || loading}
                    />
                </div>
            </div>

            <div className='flex justify-center my-20 font-thin'>
                <Link
                    href={customer_services_complain}
                    target='_blank'
                    className='mx-2'
                >
                    Inicia un reclamo público
                </Link>
                {show_complains_tyc ? (
                    <>
                        |
                        <Link href='/reclamo-tyc' className='mx-2'>
                            Términos y Condiciones del Reclamo
                        </Link>
                    </>
                ) : null}
            </div>

            <div className='flex justify-center my-20 font-thin'>
                {errors.map((error) => (
                    <p key={error} className='text-red text-center'>
                        {error}
                    </p>
                ))}
            </div>
        </form>
    );
};

export default Form;
